import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Toast, { TOAST_FADE_DURATION } from './Toast';
export const TOAST_ON_NEXT_PAGE_LOAD_STORAGE_KEY = 'toastOnNextPageLoad';
const ToastContext = React.createContext({
    toastMessages: [],
    addMessage: () => '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    dismissMessage: () => { },
});
export function ToastContainer() {
    const { toastMessages } = useContext(ToastContext);
    return (_jsx("div", Object.assign({ className: "toast-container", "aria-live": "polite", "aria-atomic": "true" }, { children: toastMessages.map((toastMessage) => (_jsx(Toast, Object.assign({ title: toastMessage.title, visible: toastMessage.visible, close: toastMessage.dismiss, autoCloseAfter: toastMessage.autoDismissAfter }, { children: toastMessage.body }), toastMessage.uuid))) })));
}
export function ToastProvider({ children }) {
    const [toastMessages, setToastMessages] = useState([]);
    const dismissMessage = useCallback((uuid) => {
        setToastMessages((prevToastMessages) => prevToastMessages.map((msg) => {
            if (msg.uuid === uuid) {
                return Object.assign(Object.assign({}, msg), { visible: false });
            }
            return msg;
        }));
        setTimeout(() => {
            setToastMessages((prevToastMessages) => {
                return prevToastMessages.filter((msg) => msg.uuid !== uuid);
            });
        }, TOAST_FADE_DURATION);
    }, []);
    const addMessage = useCallback((message) => {
        const uuid = uuidv4();
        setToastMessages((prevToastMessages) => [
            ...prevToastMessages,
            Object.assign(Object.assign({}, message), { uuid, visible: true, dismiss: () => dismissMessage(uuid) }),
        ]);
        return uuid;
    }, [dismissMessage]);
    const contextValue = useMemo(() => ({ toastMessages, addMessage, dismissMessage }), [toastMessages, addMessage, dismissMessage]);
    useEffect(() => {
        const storedToast = window.sessionStorage.getItem(TOAST_ON_NEXT_PAGE_LOAD_STORAGE_KEY);
        if (storedToast) {
            try {
                const toastParams = JSON.parse(storedToast);
                addMessage({
                    title: _jsx("strong", { children: toastParams.title }),
                    body: toastParams.body,
                    autoDismissAfter: toastParams.autoDismissAfter,
                });
            }
            catch (error) {
                Rollbar === null || Rollbar === void 0 ? void 0 : Rollbar.warn(error);
            }
            window.sessionStorage.removeItem(TOAST_ON_NEXT_PAGE_LOAD_STORAGE_KEY);
        }
    }, [addMessage]);
    return (_jsxs(ToastContext.Provider, Object.assign({ value: contextValue }, { children: [children, _jsx(ToastContainer, {})] })));
}
export function useToast() {
    const { addMessage } = useContext(ToastContext);
    return addMessage;
}
export function useToastOnNextPageLoad() {
    const toastOnNextPageLoad = useCallback((message) => {
        window.sessionStorage.setItem(TOAST_ON_NEXT_PAGE_LOAD_STORAGE_KEY, JSON.stringify(message));
    }, []);
    return toastOnNextPageLoad;
}
//# sourceMappingURL=ToastContext.js.map